import Table from 'react-bootstrap/Table';
import { useSelector, useDispatch } from 'react-redux'
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import logo from '../elia-logo-narrow.png';
import motlogo from '../mot-logo.png';
import tsatal from '../tsatal.png';
import uuid from "react-uuid";


const PopupTable = (props) => {
    // const item = useSelector((state) => state.item.value)
    // const param = useSelector((state) => state.param.value)
   
  return (
    <Table striped bordered hover size="sm">
      <thead>
        <tr>
         
          <th>יעד</th>
          <th>דרכי הגעה בתחבורה ציבורית</th>
        </tr>
      </thead>
      <tbody>
      {Object.keys(props.data).map((d)=>{
        return <tr key={uuid()}>
            <td>
                {d}
            </td>
            <td>
                {props.data[d]}
            </td>
            </tr>
      })}
    
     
      </tbody>
    </Table>
  );
}

export default PopupTable;